<template>
  <div
    class="auth-content otp-auth-content"
  >
    <!-- 타이틀 -->
    <div class="auth-title"><strong>{{"추가인증"}}</strong> {{ $t("otp.title") }}</div>
    <!-- //타이틀 -->

    <!-- 서브타이틀 -->
    <div flex fjb>
      <div class="sub-title" v-html="$t('otp.subTitle')"></div>
      <!-- 인증해제 -->
      <div
        class="modify"
        @click="removeOTPModal = true"
        v-if="authData.isOtp"
      >
        {{ $t("mypage.verify.cancelVerfication") }}
      </div>
      <!-- //인증해제 -->

    </div>
    <!-- //서브타이틀 -->

    <!-- otp 인증 전. 안내 -->
    <div
      v-if="!authData.isOtp"
      class="auth-line padding-zero"
      flex
      fic
      fjs
    >
      <div class="data" flex>
        <div class="w12 info mt12 ml12">
          {{ $t("otp.download.title") }}<br>({{
          $t("otp.download.content")
          }})
          <br />
        </div>
        <div class="otp-image w12 mt10">
          <div class="qr">
            <img :src="secretKey.qr" alt />
          </div>
          <div class="otp-info">
            <div class="name">
              {{ $t("otp.QRCode.passcode") }}
              <br>
              {{ $t("otp.qr") }}
            </div>
            <input type="text" v-model="otpForm.key" readonly />
          </div>
        </div>
        <div
          class="w12 info mt20"
        >
        </div>
        <div class="name ml12">OTP {{ $t("mypage.bank.인증번호") }}</div>
        <div class="w12 input-code">
          <input
            type="text"
            class="auth-number w12 mt4"
            v-model="otpForm.num"
            :placeholder="$t('otp.verificationCode.title')"
          />
        </div>
        <div class="otp-auth w12 ml12 mt30 mb12" flex>
          <button class="submit fs12" @click="submit()">{{ $t("otp.applicationButton") }}</button>
        </div>
      </div>
    </div>
    <!-- //otp 인증 전. 안내 -->

    <!-- otp 인증 완료 -->
    <div
      v-else-if="authData.isOtp"
      class="auth-line"
      :class="{auth: authData.isOtp}"
      flex fjb
      >
      <div class="data" flex>
        <div class="icon-otp"></div>
        <div class="ml29">
          OTP<br>{{ userInfo.authInfo.otpDate }}
        </div>
      </div>
      <div class="status" flex>
        <div>
          {{ $t("mypage.verify.verificationComplete") }}
          <img src="../../../../../src/assets/img/mypage/check_ic.svg" class="ml4" alt="">
        </div>
      </div>
    </div>
    <!-- //otp 인증 완료 -->
    <div v-else class="auth-line" flex fjb>
      <div class="data"></div>
      <div class="status"></div>
    </div>

    <!-- otp 인증 완료 모달 -->
    <el-dialog
      :title="$t('otp.popup.title')"
      :visible.sync="showModal"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      v-loading="modalSubmit"
      class="modal-type01 popup"
      center
    >
      <div class="text-center">
        <p class="text-type01" v-html="$t('otp.popup.content')"></p>
        <div class="modal-otp mt20">
          <p class="num">
            <el-input size="mini" readonly v-model="secretKey.recoveryCode"></el-input>
          </p>
          <div class="copy" @click="copy()">{{ $t("deposit.copy") }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button @click="otpModalConfirm">{{ $t("confirm.ok") }}</button>
      </span>
    </el-dialog>
    <!-- //otp 인증 완료 모달 -->

    <!-- otp 인증 해지 모달 -->
    <vs-popup :title="$t('otpCancel.title')" :active.sync="removeOTPModal">
      <p class="text-center">
        <span v-html="$t('otpCancel.content[0]')"></span>
        <br />
        <span v-html="$t('otpCancel.content[1]')"></span>
        <br />
        <br />
        <span v-html="$t('otpCancel.content[2]')"></span>
        <br />
        <br />
        {{ $t('verificationReset.24hSecurityPolicy') }}
        <br />
        <br />
        {{ $t('otpCancel.content[3]') }}
        <vs-input class="input-otp" :placeholder="$t('otp.sixDigits')" v-model="otpNumber"></vs-input>
        <br />
        {{ $t('otpCancel.content[4]') }}
      </p>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            @click="removeOTPModal = false"
            class="btn-block custom"
            type="filled"
          >{{ this.$t("confirm.cancel") }}</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            @click="otpDelete"
            class="btn-block custom"
            type="filled"
          >{{ this.$t("confirm.ok") }}</vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
    <!-- //otp 인증 해지 모달 -->

  </div>
</template>

<script>
import Api from "@/common/Api";
import Clipboard from "copy-to-clipboard";
import { mapState, mapGetters } from "vuex";

// import RemoveOtpModal from "@/components/mypage/confirmCenter/RemoveOtp";

export default {
  props: ["authData"],
  components: {
    // RemoveOtpModal,
  },
  data() {
    return {
      secretKey: {},
      otpForm: {
        key: "",
        num: ""
      },
      otpNumber: "",
      showModal: false,
      modalSubmit: false,
      removeOTPModal: false
    };
  },
  computed: {
    ...mapState(["Server"]),
    ...mapGetters(["userInfo"])
  },
  created() {
    if (!this.authData.isOtp) {
      this.getQRCode();
    }
  },
  methods: {
    getQRCode(recoveryCode = "") {
      Api.User.getOTPQrCode(recoveryCode).then(response => {
        response.body.qr = (response.body.qr || "").replace(/\&amp;/g, "&");
        this.secretKey = response.body;
        this.otpForm.key = response.body.recoveryCode;
      });
    },
    submit() {
      const { num } = this.otpForm;

      Api.User.registOTP({
        secret: this.otpForm.key,
        authNumber: this.otpForm.num
      })
        .then(response => {
          this.showModal = true;
        })
        .catch(e => {
          this.$vs.notify({
            title: "인증 실패",
            text: e.msg,
            color: "danger",
            position: "top-left"
          });
        });
    },
    otpModalConfirm() {
      this.$msgbox({
        title: "",
        message: this.$t("notice.content.OTPSettingComplete"),
        customClass: "auth-success",
        confirmButtonText: this.$t("confirm.ok"),
        showCancelButton: false,
        dangerouslyUseHTMLString: true
      });
      this.modalSubmit = true;
      this.$store.dispatch("updateUserInfo").then(() => {
        this.showModal = false;
      });
    },
    copy() {
      Clipboard(this.secretKey.recoveryCode);
      this.$vs.nofigy({
        title: this.$t("notice.title.copied"),
        text: "복사되었습니다.",
        position: "top-left"
      });
    },
    refreshPrivateData() {
      this.$store.dispatch("updateUserInfo");
      this.$emit("run", "getUserPrivateInfo");
      this.getQRCode();
      this.otpForm.key = "";
    },
    otpDelete() {
      if (this.otpValid()) {
        Api.User.terminateOTP(this.otpNumber)
          .then(response => {
            this.$vs.notify({
              duration: 3000,
              title: "완료",
              type: "warning",
              text: "OTP 설정이 해제 되었습니다.",
              customClass: "FLYBIT-noti",
              position: "top-left"
            });
            this.removeOTPModal = false;
            this.$store.dispatch("updateUserInfo").then(() => {});
            // this.getUserPrivateInfo();
            //
            // this.$refs.otpForm.resetFields();
          })
          .catch(e => {
            console.log("err", e);
            if (e) {
              this.$vs.notify({
                title: "인증",
                text: "인증번호가 잘못되었습니다.",
                position: "top-left",
                color: "danger"
              });
              this.otpNumber = "";
            }
          });
      }
    },
    otpValid() {
      if (!this.otpNumber) {
        this.$vs.notify({
          title: "인증",
          text: "인증번호를 입력해주세요.",
          position: "top-left",
          color: "danger"
        });
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scopped>
.auth-content.otp-auth-content {
  .data {
    .info {
      font-size: 12px;
      line-height: 1.8;
      color: #373237;
    }
    input {
      padding: 11px 20px;
      font-size: 13px;
    }
    .otp-image {
      position: relative;
      height: 253px;
      background-color: #f7f8fa;
      .qr {
        position: absolute;
        top: 0px;
        left: 50%;
        transform: translateX(-50%);
        height: 120px;
        margin-top: 20px;
        padding-right: 10px;
        img {
          width: 120px;
          height: 120px;
          border-radius: 4px;
          border: 1px solid #e6e6e6;
        }
      }
      .otp-info {
        position: absolute;
        left: 12px;
        bottom: 0;
        width: calc(100% - 24px);
        padding-bottom: 20px;
        .name {
          font-size: 12px;
          padding-bottom: 4px;
        }
        input {
          width: 100%;
        }
      }
    }
    .otp-auth {
      width: calc(100% - 24px);
      button {
        padding: 11px 0px;
        font-size: 14px;
        font-weight: bold;
        &.cancel {
          width: 85px;
          border: 1px solid #e6e6e6;
          background-color: #fff;
          color: #b4b4b4;
        }
        &.submit {
          width: 100%;
          font-size: 12px;
          font-weight: normal;
        }
      }
    }
  }

  .modal-otp {
    position: relative;
    .copy {
      position: absolute;
      right: 0px;
      top: 0px;
      margin-top: 0px;
      height: 28px;
      lin-eheight: 28px;
      padding: 8px 12px;
      cursor: pointer;
      font-size: 12px;
      transition: 0.2s;
      &:hover {
        color: #e10519;
      }
    }
  }
}
</style>
